import React from 'react'

export const DialogCall = <svg id="wave" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 38.05">
	<title>Audio Wave</title>
	<path id="Line_1" data-name="Line 1" d="M0.91,15L0.78,15A1,1,0,0,0,0,16v6a1,1,0,1,0,2,0s0,0,0,0V16a1,1,0,0,0-1-1H0.91Z" />
	<path id="Line_2" data-name="Line 2" d="M6.91,9L6.78,9A1,1,0,0,0,6,10V28a1,1,0,1,0,2,0s0,0,0,0V10A1,1,0,0,0,7,9H6.91Z" />
	<path id="Line_3" data-name="Line 3" d="M12.91,0L12.78,0A1,1,0,0,0,12,1V37a1,1,0,1,0,2,0s0,0,0,0V1a1,1,0,0,0-1-1H12.91Z" />
	<path id="Line_4" data-name="Line 4" d="M18.91,10l-0.12,0A1,1,0,0,0,18,11V27a1,1,0,1,0,2,0s0,0,0,0V11a1,1,0,0,0-1-1H18.91Z" />
	<path id="Line_5" data-name="Line 5" d="M24.91,15l-0.12,0A1,1,0,0,0,24,16v6a1,1,0,0,0,2,0s0,0,0,0V16a1,1,0,0,0-1-1H24.91Z" />
	<path id="Line_6" data-name="Line 6" d="M30.91,10l-0.12,0A1,1,0,0,0,30,11V27a1,1,0,1,0,2,0s0,0,0,0V11a1,1,0,0,0-1-1H30.91Z" />
	<path id="Line_7" data-name="Line 7" d="M36.91,0L36.78,0A1,1,0,0,0,36,1V37a1,1,0,1,0,2,0s0,0,0,0V1a1,1,0,0,0-1-1H36.91Z" />
	<path id="Line_8" data-name="Line 8" d="M42.91,9L42.78,9A1,1,0,0,0,42,10V28a1,1,0,1,0,2,0s0,0,0,0V10a1,1,0,0,0-1-1H42.91Z" />
	<path id="Line_9" data-name="Line 9" d="M48.91,15l-0.12,0A1,1,0,0,0,48,16v6a1,1,0,1,0,2,0s0,0,0,0V16a1,1,0,0,0-1-1H48.91Z" />
</svg>

export const DialingCall = <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xlinkHref="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 80 80" enableBackground="new 0 0 80 80" xmlSpace="preserve">
	<g id="Dialing_Capa_2">
		<g id="Dialing_Capa_1">
			<image style={{ overflow: "visible", opacity: 0.45 }} width="62" height="62" xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD4AAAA+CAYAAABzwahEAAAACXBIWXMAAAsSAAALEgHS3X78AAAA
				GXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAABwdJREFUeNrUW4ly4kYQHaGDywRs
				x07iZLNJ/v+fkk02m8SJ19iwHLJAGVW9Lh7NjBCYtWdV1YWQBej1Nd2vx5GpPyJz3FGawI+o5lqk
				zg8BXKrz4I7EAbqSlpKoAXgBu1YSJPjEATrG9ZSEFeADLUCfSAorqxDBJw7QFdCulb6VHs4z/M1l
				ebF0BTC3Mrcys/IJ5yZE8GzxFt5XQEdWLqxcWvkKChDLc8wLELF0BfjRyp2Vjw7FBGnxFsD1Afh7
				yNdWBlbaHncXN19amVj5D8qLyOVXuCcoi0cO4BcA/YuVGytDKx1ydw28Araw8mDlA67PoYhPCAH5
				nTJEV08BcAhLV6DfwPW7DYDf45pY/laFSNDJLQPIARRQgT5vCFxAS15o4zdazyiGXnQ5S6GADgB3
				G7h6BPA9uj9T4fRFFDCxR1zAI4DPYOUORCwehxzjGnyduD4jy2GmvCTzKOxVj1MkHe0lbYDm4ic5
				oPR9VeClajSaKiB25IY2rgeV4Fo1gMsDFKDrfI7zLMTM3vLU3Fqagm85gLdpLQ/O1bmlXKHMzB3l
				ZtkQeOoAHodscemwFig553i/ot66SawnVAukobq6tnaOLmsG4EtYfn1EwjMOFw/C3bXFCwCdo7mQ
				nvqpprtixRW4dwnxhUsZUoxri1egpzjPAUqDZ9ACeIqe/AGvn3B9FSoRUVJiWwDAFA++UMBLx2fm
				APoRXdk/ICQeHZ8PBri23BygJ3jlJJd46KYK4L9W/rTyB/ryW1h+DuBBWtxQnIrFxV2ncNcCWVru
				zeERY4CuwL6z8puV9+jJJ/TZ4CyuC5glAEmsTijJZZQIZyAf/oal30Eqi/8Ft59RcgzmiNX6a1Sz
				0QMZMSRyQZS1hFJuAfRXyO8EeqoSWzCurpczo5LVBG48JqvnlMFn+NstLP4e1r/D/cEltX1NisT5
				BK58D4BTXJdhQU6JkJewWYhxvY+IWKs4HyNJ3YF97SEs1lSfR456IEjArhg3Nfxbh8iFDq5FsOic
				VoAJFSxFyOBjD2gf+cjgM+LalggBru+L0Kq1JhbXCtCW7yrLc8W3oMaGu7pjFbCP7zu5q5cOy2eK
				TxMWNaKCRtra3FPmHsrjRarDO0mnFx94r8vqGX3PWpEYxRGJjhUtVFZCvJ1rbu9SRvRcVzc1Lq8Z
				Fi57CwV83RA0szhMYTF/xzx/U2UcbXGu6oQ/b5NoekmWtaIhfaU5uz6qxRFkYDYz+zZ+XxielBSS
				KFY3arqOm5r6XTowjnNJcn08HG8DKT0JShKfVqpY+Qxl8jleewBT0AoiRMeScssTKbt2Z0bSwMql
				IijGZndo0Dbbk9ZSgeaR1CM1PLLcCU/XgfKq+fw3Vr41m/l8YjbDSeEEZQldUDmde1gkw+CbAjdk
				9Sm5Y5ckQ2XXhmtq0Cm554PZzM3X1BQNzGY8/aOVH6CAIT7P/T8TojO6tsB3P5ianRlJw9guVa8u
				829OPBLjI4AbORIiJ6kUD1zgOXgnxk+QNwA+wP0lrRq5w/riARySzp0ZyYHJjRmaB7IgT0sMYlPA
				+8reLr7jCZ8dwbXfWvkZwG/gRX0y0krFMbu3uPg9lGWMZ2fGIcDZ5YV50eNjzqBi+aEDeA8J7B4P
				m0JZYu23Znf/Tay8b222pz2iiBm+25DlxSNbTbN6k3jXgLlDO8ePnpntEXIfirlTwL9DXN8Q6C5V
				h3q10ZsKCyipBOiB8WxXOxS4K96N46F4OTkH0C6VvT0AfwDwxGz23VzDvQdQWlJTb+gtpDFeuyqX
				7HjkMcCNYmRda35O6+2CrJcCYBvFiSS3GA8rFFff7A4b66pLBh47KrudQuZY4HXgef7GbeqV2Wwb
				Ew8Y0QNn5vjRcuQplLx1+3OAa/B6GrOgNVYUcA2wfSp1E8r8qSo5X5R6ek7M8zlXUDKSmgD8Jazf
				dzQaLzJQTE70PaVqQrhBWSp6aoyi5ApJbEhre0nJqGzSZb02cL3U6U0GC2JimbW9QuIbIvn1HNnY
				tWc+qmmoGm1hSU7sQT7wuaqh71FDXwP4JXVi0n5yknO1mr6NhivVBjtJkOQzhA9v5S7Vur6gWBfa
				+hIi28RHUMCZ8oBsT6/N7XPdbP6zAXdZf62Snri+DBtlv+wF5JzAn5ntrWO+pU6suyCqWw82zEsA
				57iLauJ+jNKVNw3zvE7A9xWvHztGYEJ4TjDK4vndFs+fmJc5tPVdGV82FfQBdEDnDJxr75ane5zh
				uz6Y3YltedLl4UDqmEkK5vFSKmw6qqOr2x8bOWiyCUDfmd3J7fo1dx9FDg69pSjllJibtnFvH4s8
				xdSSqKedIWYo+860F2hFxA0Z1FJR3JpwfFVXb6IA3XD4Jir7llPvP/+FBrzOE8yBpWtp3P/yab4E
				4PumO4esKFvH/wIMAL0jMNdj6wkIAAAAAElFTkSuQmCC" transform="matrix(1 0 0 1 11 11)">
			</image>
			<g>
				<g>
					<g>
						<g id="Group_2778_10_" transform="translate(361.8 194.8)">
							<path id="Path_506_13_" className="st0" d="M-337.4-157.9c3.9,7.8,10.2,14.1,18,18l6.2-6.3c0.8-0.8,1.6-0.8,3.1-0.8
							c3.1,0.8,6.2,1.6,10.2,1.6c1.6,0,3.1,1.6,3.1,3.1v9.4c0,1.6-1.6,3.1-3.1,3.1c-25.8,0-46.9-21.1-46.9-46.9l0,0
							c0-1.6,1.6-3.1,3.1-3.1l0,0h9.4c1.6,0,3.1,1.6,3.1,3.1c0,3.1,0.8,7,1.6,10.2c0,0.8,0,2.3-0.8,3.1L-337.4-157.9z"/>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
</svg>

export const iconExlcusiveCallBackState = <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xlinkHref="http://www.w3.org/1999/xlink" x="0px" y="0px"
	viewBox="0 0 24 24" enableBackground="new 0 0 24 24" xmlSpace="preserve">
	<g>
		<path className="cbe_st0 cbe_linea" d="M2.2,10.4c0.9-5.4,6-9.1,11.4-8.2c3,0.5,5.5,2.3,7,4.8" />
	</g>
	<g className="cbe_telefonos">
		<path className="cbe_st1" d="M14.1,13.2l-1.4,1.4c-0.7-0.3-1.4-0.8-1.9-1.4c-0.6-0.6-1-1.2-1.4-1.9l1.4-1.4L10.4,7H7.1c-0.3,1.9,0.1,3.8,1,5.6
		c0.4,0.7,0.9,1.3,1.4,1.9c0.6,0.6,1.2,1,1.9,1.4c1.7,1,3.7,1.3,5.6,1v-3.3L14.1,13.2z"/>
		<path className="cbe_st1_01" d="M14.1,13.2l-1.4,1.4c-0.7-0.3-1.4-0.8-1.9-1.4c-0.6-0.6-1-1.2-1.4-1.9l1.4-1.4L10.4,7H7.1c-0.3,1.9,0.1,3.8,1,5.6
		c0.4,0.7,0.9,1.3,1.4,1.9c0.6,0.6,1.2,1,1.9,1.4c1.7,1,3.7,1.3,5.6,1v-3.3L14.1,13.2z"/>
	</g>
	<g className="cbe_opacidad_triangulo">
		<polygon className="cbe_st1 cbe_triangulo" points="17.6,7.3 21.8,10.7 22.7,5.4 	" />
	</g>
	<circle className="cbe_st1 cicle_trans_01" cx="2.2" cy="13.6" r="1.1" />
	<circle className="cbe_st1 cicle_trans_02" cx="4.5" cy="18.5" r="1.1" />
	<circle className="cbe_st1 cicle_trans_03" cx="9" cy="21.4" r="1.1" />
	<circle className="cbe_st1 cicle_trans_04" cx="14.4" cy="21.6" r="1.1" />
	<circle className="cbe_st1 cicle_trans_05" cx="19.1" cy="18.9" r="1.1" />
	<circle className="cbe_st1 cicle_trans_06" cx="21.6" cy="14.2" r="1.1" />
</svg>

export const EstadoAgenteDispLlamManual = <svg version="1.1" id="headphones" xmlns="http://www.w3.org/2000/svg" xlinkHref="http://www.w3.org/1999/xlink"
	viewBox="0 0 56 61.8" xmlSpace="preserve">
	<path className="audi_path audi_diadema" d="M45.4,28.5c0,0,0-3,0-5s-1.4-6.6-3-9.6c-0.9,0-1.8-0.5-2.3-1.2c-6.3-8.9-21.9-8.9-28.2,0
		c-0.5,0.8-1.4,1.2-2.3,1.2c-1.6,2.9-2.7,6.3-3,9.3c-0.2,2.4,0,4.8,0,4.9c0,0,0,1.8-1.6,1.8s-1.6-1.8-1.6-1.8c0-0.3,0-2.2,0-2.5
		c0.2-4.6,1.4-9,3.6-13c-0.5-0.8-0.5-1.9,0.1-2.6c4.3-6.1,11.4-9.6,18.9-9.3c7.6,0.1,14.4,3,18.8,9.3c0.6,0.8,0.7,1.8,0.1,2.6
		c2.1,4,3.3,8.5,3.5,13v2.9c0,0-0.1,1.4-1.5,1.4S45.4,28.5,45.4,28.5z"/>
	<path className="audi_path" d="M7.3,23.2h2.6c1,0,3.2,1.2,3.2,2.2v15.5c0,1-1.8,2.3-3.3,2.3c-1.2,0-3.3-0.1-4.2-2.7
		C3,40.2,1.1,38.2,1,35.7v-5.2c0-1.6,0.9-3.2,2.3-4C3.3,26.5,3.5,23.2,7.3,23.2z"/>
	<path className="audi_path audi_microfono" d="M5.1,38.4c0.7,5.4,2.8,7.6,4.2,9.1c1.9,1.8,4.1,3.2,6.6,4c0.2,1.4,1.2,2.6,2.6,2.9l6.7,1.4
		c1.8,0.4,3.5-0.8,3.9-2.6l0.2-0.8c0.4-1.8-0.8-3.5-2.6-3.9L20,47.1c-1.3-0.3-2.7,0.3-3.5,1.5c-1.9-0.7-3.7-1.7-5.1-3.1
		c-2.9-2.6-3.2-7.1-3.2-7.1s-0.1-1.8-1.7-1.8S5.1,38.4,5.1,38.4z"/>
	<path className="audi_path" d="M48.3,26c2.1,0.6,2.7,2.3,2.7,4.5v5.2c0,2.6,0,4.7-4,4.8v0.4c-0.2,1.2-1.1,2.1-2.3,2.3h-2.6
		c-1,0-3.1-1.3-3.1-2.3V25.3c0-1,2.1-2.2,3.1-2.2c0,0,3.8-0.4,5.1,0.7C48.2,24.6,48.3,26,48.3,26z"/>
	<path className="audi_st0" d="M29.6,47.5c2.5,2.8,2.3,7.2-0.5,9.8" />
	<path className="audi_st0" d="M32.4,46c3.4,3.8,3.1,9.7-0.7,13.1" />
	<path className="audi_st0" d="M35.3,44.3c4.4,4.9,3.9,12.3-0.9,16.7" />
</svg>

export const EstadoAgenteNotas = <svg version="1.1" id="wrapupAnimation" xmlns="http://www.w3.org/2000/svg" xlinkHref="http://www.w3.org/1999/xlink" x="0px" y="0px"
	viewBox="0 0 74.3 73.7" xmlSpace="preserve">
	<g id="todoNotas">
		<g>
			<g id="Group_2498_1_">
				<g transform="matrix(1, 0, 0, 1, -894.31, 2170.92)">
					<path id="Path_1187-2_1_" className="st0 path" d="M912-2144.1v35c0,0.5,0.7,1,1.3,1h36.5c0.6,0,1.1-0.4,1.2-1v-49.8
		   c-0.1-0.6-0.6-1.1-1.2-1.2h-21.9c-0.3,0-0.6,0.1-0.9,0.2v11.8c0,1.7-1.3,3-3,3h-11.8C912.1-2144.8,912-2144.4,912-2144.1"/>
				</g>
			</g>
			<g id="Group_2499_1_">
				<path id="Path_1188_1_" className="st0" d="M30.7,22.8V12.3L19.2,23.8h10.5C30.2,23.8,30.7,23.4,30.7,22.8" />
			</g>
		</g>
		<g>
			<line className="wrapupst1" x1="23" y1="30" x2="50" y2="30" />
			<line className="wrapupst2" x1="23" y1="38" x2="48" y2="38" />
			<line className="wrapupst3" x1="23" y1="46" x2="40" y2="46" />
			<line className="wrapupst4" x1="23" y1="53" x2="30" y2="53" />
		</g>
	</g>
</svg>

export const EstadoAgenteError = <svg version="1.1" id="errorAnimation" xmlns="http://www.w3.org/2000/svg" xlinkHref="http://www.w3.org/1999/xlink"
	viewBox="0 0 56 56" xmlSpace="preserve">
	<g className="todoError">
		<circle className="errst0" cx="28" cy="28" r="22.5" />
		<g className="errsigno">
			<line className="errst1" x1="28.1" y1="15.5" x2="28.1" y2="30.5" />
			<line className="errst2" x1="28.1" y1="35.5" x2="28.1" y2="40.5" />
		</g></g>
</svg>

export const EstadoAgenteTransferenciaAni = <svg version="1.1" id="Transfer" xmlns="http://www.w3.org/2000/svg" xlinkHref="http://www.w3.org/1999/xlink"
	x="0px" y="0px" viewBox="0 0 74.4 74.4" enableBackground="new 0 0 74.4 74.4;" xmlSpace="preserve">
	<g className="tel">
		<path className="transfer_st0 transfer_tel" d="M9.1,47.1v9.8c0,1.5,1.3,2.8,2.8,2.8c26.3,0,47.5-21.3,47.5-47.5c0,0,0,0,0,0c0-1.5-1.3-2.8-2.8-2.8h-9.8
		c-1.5,0-2.8,1.3-2.8,2.8c0,3.4-0.5,6.8-1.6,10c-0.3,1-0.1,2.1,0.7,2.8l6.2,6.2c-4,7.9-10.5,14.4-18.4,18.4l-6.2-6.2
		c-0.8-0.7-1.8-1-2.9-0.7c-3.2,1.1-6.6,1.6-10,1.6C10.3,44.3,9.1,45.6,9.1,47.1"/>
		<path className="transfer_st0 transfer_tel_02" d="M9.1,47.1v9.8c0,1.5,1.3,2.8,2.8,2.8c26.3,0,47.5-21.3,47.5-47.5c0,0,0,0,0,0c0-1.5-1.3-2.8-2.8-2.8h-9.8
		c-1.5,0-2.8,1.3-2.8,2.8c0,3.4-0.5,6.8-1.6,10c-0.3,1-0.1,2.1,0.7,2.8l6.2,6.2c-4,7.9-10.5,14.4-18.4,18.4l-6.2-6.2
		c-0.8-0.7-1.8-1-2.9-0.7c-3.2,1.1-6.6,1.6-10,1.6C10.3,44.3,9.1,45.6,9.1,47.1"/>
	</g>
	<g className="fecha_content_01">
		<path className="transfer_st0 flecha_01" d="M33.1,17.7l-5.9-5.9L19.1,20L15.2,16v14.4H29L24.8,26L33.1,17.7z" />
	</g>
	<g className="fecha_content_01">
		<path className="transfer_st0 flecha_03" d="M33.1,17.7l-5.9-5.9L19.1,20L15.2,16v14.4H29L24.8,26L33.1,17.7z" />
	</g>
	<g className="fecha_content_01">
		<path className="transfer_st0 flecha_02" d="M65.3,47.4H51.2l4.1,3.9l-8.2,8.1l5.9,5.9l8.2-8.2l4,4V47.4z" />
	</g>
	<g className="fecha_content_01">
		<path className="transfer_st0 flecha_04" d="M65.3,47.4H51.2l4.1,3.9l-8.2,8.1l5.9,5.9l8.2-8.2l4,4V47.4z" />
	</g>
</svg>

export const EstadoAgenteNoDisponibleAni = <svg version="1.1" id="NoAvaiable" xmlns="http://www.w3.org/2000/svg" xlinkHref="http://www.w3.org/1999/xlink" x="0px" y="0px"
	viewBox="0 0 58.4 60.6" enableBackground="new 0 0 58.4 60.6;" xmlSpace="preserve">
	<g transform="matrix(1, 0, 0, 1, -1.12, -1.16)">
		<path id="Path_3501-2" className="NoAvaiablest0" d="M28.5,50.3L21.8,49c-1.3-0.3-2.7,0.3-3.5,1.5c-2.1-0.7-3.8-1.3-5.1-2.7
   c-0.7-0.7-1.3-0.9-1.8-1.9h0.2c1,0,1.6-2.2,1.6-3.2V27.1c0-1-0.6-1.2-1.6-1.2H9c-0.3,0-0.6-0.2-0.8-0.1c0.3-3.5,1.4-6.9,3-10
   c0.9,0,1.8-0.5,2.3-1.3c6.3-8.9,21.9-9,28.3,0c0.5,0.8,1.4,1.2,2.3,1.2c1.7,3.1,2.7,6.5,3,10c-0.2-0.1-0.4,0.1-0.6,0.1H44
   c-1,0-3.8,0.2-3.8,1.2v5.7c1.1-0.2,2.2-0.3,3.3-0.4c3.2,0,6.3,1.1,8.7,3.3v-3.4c0-2.1-0.2-3.9-2.4-4.5c0-0.1,0.3-0.3,0.3-0.4
   c-0.1-4.6-1.3-9-3.4-13.1c0.5-0.8,0.5-1.9-0.1-2.6c-4.5-6.3-11.2-9.2-18.9-9.3c-7.5-0.3-14.6,3.2-18.9,9.3
   c-0.6,0.8-0.7,1.8-0.1,2.6c-2.2,4-3.4,8.5-3.6,13.1c0,0.3-0.3,0.6-0.3,0.9c-1.5,0.8-2.4,2.3-2.6,4v5.2c0,2.6,2.5,4.6,4.7,4.8
   c0,0.2,0.2,0.3,0.2,0.5c0,0.5,0.2,1,0.5,1.4c0.7,1.9,1.8,3.7,3.3,5.1c1.9,1.9,4.1,3.2,6.6,4c0.2,1.4,1.2,2.6,2.7,2.9l6.7,1.4
   c1.8,0.4,3.6-0.8,3.9-2.6l0.2-0.8C31.5,52.4,30.3,50.7,28.5,50.3"/>
	</g>
	<g>
		<g id="Group_6176">
			<g id="Path_3499-2" transform="matrix(1, 0, 0, 1, -1.12, -1.16)">
				<path className="NoAvaiablest1" d="M35,45.1c0-5.6,4.5-10.1,10.1-10.1c5.6,0,10.1,4.5,10.1,10.1c0,5.6-4.5,10.1-10.1,10.1
		   C39.6,55.2,35,50.7,35,45.1"/>
				<path className="NoAvaiablest0" d="M39.4,50.9l-1.8-1.8l11.2-11.2l1.8,1.8L39.4,50.9z" />
			</g>
		</g>

	</g>
</svg>



export const EstadoAgenteMedios = (props) => <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" xmlnsXlink="http://www.w3.org/1999/xlink"
	viewBox="0 0 24 24" style={{ enableBackground: 'new 0 0 24 24', fill: "#fff", height:props.height ? props.height : '2rem', width: '2rem' }} xmlSpace="preserve">
	<path d="M11.96,4.06c-4.42,0-8,3.58-8,8c0,2.03,0.76,3.88,2,5.29v4.71l3.57-2.38c0.77,0.24,1.58,0.38,2.43,0.38c4.42,0,8-3.58,8-8
S16.38,4.06,11.96,4.06z"/>
</svg>



// WEBPACK FOOTER //
// ./src/Images/AgentStatusSVG.js